import { Store } from 'utils';

const TOKEN = 'token';

class AuthStore extends Store {

	getInitialState() {
		return {
			token: window.localStorage.getItem(TOKEN),
			loading: false,
			msg: null,
			providers: {
				fb: null,
				google: null,
			},
		}
	}

	onLoginStatusChanged(state, data) {
		if(data.auth) {
			window.localStorage.setItem(TOKEN, data.auth.token);
			state.token = data.auth.token;
		} else {
			state.token = null;
		}

		state.loading = data.loading;
		state.msg = data.msg;
	}

	onPavilionsChanged(state, data)
	{
		state.providers = {
			fb: data.fbAppId,
			google: data.googleClientId,
		};
	}

	isAuthorized() {
		return this.getState().token != null;
	}

	isLoading() {
		return this.getState().loading;
	}

	getToken() {
		return this.getState().token;
	}

	getProviders()
	{
		return this.getState().providers;
	}

	getMessage() {
		return this.getState().msg;
	}
}

const store = new AuthStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/authstore.js